
// additional suing translations, keeping separate from translations-*.ts in case those are updated in sui
export const TRANSLATIONS_SUING_ES = {
  report: {
    downloadExcelWorkbook: 'Download as Excel Workbook (.xlsx)'
  }
}
